export const DISTRIBUTORS = {
	GET_ALL_DISTRIBUTORS: 'DISTRIBUTORS_GET_ALL_DISTRIBUTORS',
	SET_ALL_DISTRIBUTORS: 'DISTRIBUTORS_SET_ALL_DISTRIBUTORS',
	CREATE_NEW_DISTRIBUTOR: 'DISTRIBUTORS_CREATE_NEW_DISTRIBUTOR',
	SET_DISTRIBUTOR: 'DISTRIBUTORS_SET_DISTRIBUTOR',
	SET_DISTRIBUTORS_PAGINATION: 'DISTRIBUTORS_SET_DISTRIBUTORS_PAGINATION',
	DELETE_DISTRIBUTOR: 'DISTRIBUTORS_DELETE_DISTRIBUTOR',
};
